export enum ControlEventType {
  FEED_DOWN,
  FEED_UP,
  PROVIDER_DOWN,
  PROVIDER_UP,
  SUBSCRIPTION_END,
  SUBSCRIPTION_START,
}

export namespace ControlEventType {
  let elements = [
    ControlEventType.FEED_DOWN,
    ControlEventType.FEED_UP,
    ControlEventType.PROVIDER_DOWN,
    ControlEventType.PROVIDER_UP,
    ControlEventType.SUBSCRIPTION_END,
    ControlEventType.SUBSCRIPTION_START,
  ];
  let alias = "com.bcdfx.streaming.ControlEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
